import axios from 'axios';
import {
  handleAPI
} from '../tools/http';

let api = handleAPI({
  cityOptions: '/api/weather/admin/cityOptions',
  weatherOfDay: '/api/weather/admin/watherOfDay',
});


export default class Analysis {
  constructor() {
    //选项集
    this.options = {
      cityList: [],
    }
    // 选项的查询参数
    this.query = {
      adcode: '',
      date: new Date(new Date().getTime())
    }
    // 时段天气数据
    this.durationData = [];

    this.init();
  }
  /**初始化数据 */
  async init() {
    return new Promise(async resolve => {
      this.options.cityList = await this.fetchCityOptions(); // 获取城市数据
      if (this.options.cityList.length) {
        this.query.adcode = this.options.cityList[0].adcode;
      }
      const {
        adcode,
        date
      } = this.query;

      const durationData = await this.fetchDurationData(adcode, date);
      this.setDurationData(durationData)
    })
  }
  /**请求城市的选项 */
  async fetchCityOptions() {
    return axios.get(api.cityOptions).then(res => {
      return res.data;
    })
  }
  /**请求时段天气数据 */
  async fetchDurationData(adcode, date) {
    return axios.get(api.weatherOfDay, {
      params: {
        adcode,
        date
      }
    }).then(res => {
      return res.data;
    });
  }
  /**设置时段天气数据 */
  setDurationData(data) {
    this.durationData = data;
  }
}